import Vue from 'vue'
import Router, { RouteConfig } from 'vue-router'
import Layout from '@/layout/index.vue'

Vue.use(Router)

/*
  redirect:                      if set to 'noredirect', no redirect action will be trigger when clicking the breadcrumb
  meta: {
    title: 'title'               the name showed in subMenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon showed in the sidebar
    breadcrumb: false            if false, the item will be hidden in breadcrumb (default is true)
    hidden: true                 if true, this route will not show in the sidebar (default is false)
  }
*/
export const asyncRoutes: RouteConfig[] = [
  {
    path: '/ranking',
    component: Layout,
    meta: {
      permissions: ['漏点管理', '上帝'],
      onlyShowInPC: true
    },
    children: [
      {
        path: '',
        component: () => import(/* webpackChunkName: "leak_ranking" */ '@/views/orgAdmin/analysis/RankingIndex.vue'),
        meta: {
          title: '统计排名',
          icon: 'chart',
        }
      }
    ]
  },
  {
    path: '/org-admin-leaks',
    component: Layout,
    meta: {
      permissions: ['漏点管理', '上帝'],
      onlyShowInPC: true
    },
    children: [
      {
        path: '',
        component: () => import(/* webpackChunkName: "org_admin_leaks" */ '@/views/orgAdmin/leaks/index.vue'),
        meta: {
          title: '漏点管理',
          icon: 'water-drop',
          breadcrumb: true,
          permissions: ['漏点管理', '上帝'],
          onlyShowInPC: true
        }
      }
    ]
  },
  {
    path: '/base-data',
    component: Layout,
    meta: {
      permissions: ['基础数据管理', '上帝'],
      onlyShowInPC: true
    },
    children: [
      {
        path: '',
        component: () => import(/* webpackChunkName: "base_data" */ '@/views/baseData/index.vue'),
        meta: {
          title: '基础数据管理',
          icon: 'documentation',
          breadcrumb: true,
          permissions: ['基础数据管理', '上帝'],
          onlyShowInPC: true,
        }
      }
    ]
  },
  {
    path: '/super-admin-orgs',
    component: Layout,
    meta: {
      permissions: ['上帝'], // 只允许超级管理员访问
      onlyShowInPC: true
    },
    children: [
      {
        path: '',
        component: () => import(/* webpackChunkName: "super_admin_orgs" */ '@/views/superAdmin/orgs/index.vue'),
        meta: {
          title: '租户管理',
          icon: 'peoples',
          breadcrumb: true,
          permissions: ['上帝'], // 只允许超级管理员访问
          onlyShowInPC: true,
        }
      }
    ]
  },
  {
    path: '/super-admin-users',
    component: Layout,
    meta: {
      permissions: ['上帝'], // 只允许超级管理员访问
      onlyShowInPC: true
    },
    children: [
      {
        path: '',
        component: () => import(/* webpackChunkName: "super_admin_users" */ '@/views/superAdmin/users/index.vue'),
        meta: {
          title: '所有用户列表',
          icon: 'people',
          breadcrumb: true,
          permissions: ['上帝'], // 只允许超级管理员访问
          onlyShowInPC: true
        }
      }
    ]
  },
  {
    path: '/projects',
    component: Layout,
    meta: {
      permissions: ['项目管理', '上帝'],
      onlyShowInPC: true
    },
    children: [
      {
        path: '',
        component: () => import('@/views/orgAdmin/projects/index.vue'),
        name: 'ProjectManagement',
        meta: {
          title: '项目管理',
          icon: 'clipboard',
          permissions: ['项目管理', '上帝'],
          onlyShowInPC: true
        }
      }
    ]
  },
  {
    path: '/depts',
    component: Layout,
    meta: {
      permissions: ['部门管理', '上帝'],
      onlyShowInPC: true
    },
    children: [
      {
        path: '',
        component: () => import(/* webpackChunkName: "org_admin_depts" */ '@/views/orgAdmin/depts/index.vue'),
        meta: {
          title: '部门管理',
          icon: 'tree',
          breadcrumb: true,
          permissions: ['部门管理', '上帝'], // 只允许组织管理员访问
          onlyShowInPC: true
        }
      }
    ]
  },
  {
    path: '/users',
    component: Layout,
    meta: {
      permissions: ['用户管理', '上帝'],
      onlyShowInPC: true
    },
    children: [
      {
        path: '',
        component: () => import(/* webpackChunkName: "org_admin_users" */ '@/views/orgAdmin/users/index.vue'),
        meta: {
          title: '用户管理',
          icon: 'user',
          breadcrumb: true,
          permissions: ['用户管理', '上帝'], // 只允许组织管理员访问
          onlyShowInPC: true
        }
      }
    ]
  },
  {
    path: '/roles',
    component: Layout,
    meta: {
      permissions: ['权限管理', '上帝'],
      onlyShowInPC: true
    },
    children: [
      {
        path: '',
        component: () => import(/* webpackChunkName: "org_admin_roles" */ '@/views/orgAdmin/roles/index.vue'),
        meta: {
          title: '角色管理',
          icon: 'lock',
          breadcrumb: true,
          permissions: ['权限管理', '上帝'], // 只允许组织管理员访问
          onlyShowInPC: true
        }
      }
    ]
  },
]
export const constantRoutes: RouteConfig[] = [
  {
    path: '/login',
    component: () => import(/* webpackChunkName: "login" */ '@/views/login/index.vue'),
    meta: { hidden: true, title: '登录' }
  },
  {
    path: '/select_org',
    component: () => import(/* webpackChunkName: "select_org" */ '@/views/selectOrg/index.vue'),
    meta: { hidden: true, title: '选择租户' }
  },
  {
    path: '/404',
    component: () => import(/* webpackChunkName: "404" */ '@/views/404.vue'),
    meta: { hidden: true, title: '404' }
  },
  {
    path: '/',
    component: Layout,
    redirect: '/leaks',
    meta: { hidden: true },
    children: [
      {
        path: 'dashboard',
        component: () => import(/* webpackChunkName: "dashboard" */ '@/views/dashboard/index.vue'),
        meta: {
          title: 'Dashboard',
          icon: 'dashboard'
        }
      }
    ]
  },
  {
    path: '/leak-detail',
    component: Layout,
    meta: {
      hidden: true,
    },
    children: [
      {
        path: '/view/:id',
        name: 'LeakDetail',
        component: () => import(/* webpackChunkName: "leak_detail" */ '@/views/leaks/LeakDetailPage.vue'),
        meta: {
          title: '漏点详情',
          hidden: true,
        }
      },
      {
        path: '/edit-detection/:id',
        name: 'LeakEditDetection',
        component: () => import(/* webpackChunkName: "leak_edit" */ '@/views/leaks/LeakDetectionEdit.vue'),
        meta: {
          title: '漏点编辑',
          hidden: true,
        }
      },
      {
        path: '/edit-repair/:id',
        name: 'LeakEditRepair',
        component: () => import(/* webpackChunkName: "leak_edit" */ '@/views/leaks/LeakRepairEdit.vue'),
        meta: {
          title: '漏点编辑',
          hidden: true,
        }
      }
    ]
  },
  {
    path: '/create-leak',
    component: Layout,
    meta: {
      hidden: true,
    },
    children: [
      {
        path: '',
        name: 'CreateLeak',
        component: () => import(/* webpackChunkName: "create_leak" */ '@/views/leaks/LeakCreatePage.vue'),
        meta: { hidden: true, title: '创建漏点' }
      }
    ]
  },
  {
    path: '/leaks',
    component: Layout,
    children: [
      {
        path: '',
        component: () => import(/* webpackChunkName: "leak_list" */ '@/views/leaks/LeakListIndex.vue'),
        meta: {
          title: '我的任务',
          icon: 'excel',
        }
      }
    ]
  },
  {
    path: '/maps',
    component: Layout,
    children: [
      {
        path: '',
        component: () => import(/* webpackChunkName: "leak_map" */ '@/views/leaks/LeakMapIndex.vue'),
        meta: {
          title: '地图模式',
          icon: 'international',
        }
      }
    ]
  },
  {
    path: '/profile',
    component: Layout,
    meta: { hidden: true },
    children: [
      {
        path: '',
        component: () => import(/* webpackChunkName: "profile" */ '@/views/profile/index.vue'),
        meta: {
          title: '个人信息',
          icon: 'user'
        }
      }
    ]
  },
]

const createRouter = () => new Router({
  mode: 'history',  // Enable this if you need.
  scrollBehavior: (_to, _from, savedPosition) => {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
  base: process.env.BASE_URL,
  routes: constantRoutes
})

const router = createRouter()

export function resetRouter() {
  const newRouter = createRouter();
  (router as any).matcher = (newRouter as any).matcher // reset router
}

export function goBack() {
  window.addEventListener('popstate', function once() {
    window.removeEventListener('popstate', once)
    window.location.reload()
  })
  router.go(-1)
}

export default router
